<script>
import Step from "../../wizard/components/Step";
import EditUser from "./data/EditUser";
import API from "../../../API";
import UserValidator from "./data/UserValidator";
import toaster from "../../common/toaster"

import WizardSteps from "../../wizard/components/wizard-steps.vue";
import WizardBody from "../../wizard/components/wizard-body.vue";
import MyuserCard from "../myuser/components/myuser-card.vue";
import WizardFooter from "../../wizard/components/wizard-footer.vue";
import UserWizardHeader from "./components/user-wizard-header.vue";
import UserWizardProjects from "./components/user-wizard-projects.vue";
import UserWizardGrouping from "./components/user-wizard-grouping.vue";
import UserWizardDone from "./components/user-wizard-done.vue";
import SelectField from "../../common/select-field.vue";
import TextField from "../../common/text-field.vue";
import {translations} from "./data/variables";
import UserWizardGeneral from "./components/user-wizard-general.vue";
import Loading from "../../common/loading.vue";
import ConfirmDialog from "../../dialog/confirm-dialog.vue";

export default {
    name: "user-wizard",
    components: {
        ConfirmDialog,
        Loading,
        UserWizardGeneral,
        TextField,
        SelectField,
        UserWizardDone,
        UserWizardGrouping,
        UserWizardProjects,
        UserWizardHeader,
        MyuserCard,
        WizardFooter,
        WizardBody,
        WizardSteps
    },
    props: {
        show: Boolean,
        addMode: Boolean,
        id: Number
    },
    data() {
        const steps = [
            new Step(0, Lang.langGet('General')),
            new Step(1, Lang.langGet('Projects')),
            new Step(2, Lang.langGet('Permissions')),
            new Step(3, Lang.langGet('Done')),
        ]
        return {
            errors: [],
            errored: false,
            processing: false,
            duplicateEmailError: false,
            validator: new UserValidator(),
            steps: steps,
            currentStep: 0,
            currentlyManagedProjectId: -1,
            user: new EditUser(),
        }
    },
    computed: {
        translations() {
            return translations
        },
        doneMessage() {
            if (this.errored) {
                return this.addMode ? Lang.langGet('Adding user failed') : Lang.langGet('Editing user failed');
            }
            return this.addMode ? Lang.langGet('User added successfully') : Lang.langGet('User saved successfully');
        },
        generalMessage() {
            if (this.addMode) {
                return Lang.langGet('Fill out general information about your new user');
            } else {
                return Lang.langGet('Fill out general information about your user');
            }
        },
        projectsMessage() {
            return Lang.langGet('Assign projects to :firstName :lastName', {firstName: this.user.firstName, lastName: this.user.lastName});
        },
        groupingMessage() {
            return Lang.langGet('Select privilege and user groups for :firstName :lastName', {firstName: this.user.firstName, lastName: this.user.lastName});
        },
        userExistsMsg() {
            return Lang.langGet("A user with the email :email already exists. Do you want to add the existing user to the following project(s)?", {email: this.user.email});
        },
                projectNames() {
            return this.user.selectedProjects.map(project => project.name).join(', ');
        },
    },
    methods: {
        handleChange(property, value) {
            switch (property) {
                case 'currentlyManagedProjectId': {
                    this.currentlyManagedProjectId = value;
                    break;
                }
                case 'selectedProjects': {
                    this.user.updateProject(value);
                    break;
                }
                case 'usergroups': {
                    this.user.updateUsergroups(value);
                    break;
                }
                case 'privilegegroups': {
                    this.user.updatePrivilegegroups(value);
                    break;
                }
                case 'level': {
                    this.user.updateLevel(value);
                    break;
                }
                case 'isLdap': {
                    if (value) {
                        this.user.firstName = "LDAP Role";
                        this.validator.update('firstName', true);
                        this.validator.update('passwords', true);

                        this.addActiveProjectAsDefaultSelected(false);
                        this.user.selectedProjects = [];
                    } else {
                        this.user.firstName = null;
                        this.validator.update('firstName', false);
                        this.addActiveProjectAsDefaultSelected();
                    }
                    this.user.isLdap = value;
                    break;
                }
                default: {
                    this.user[property] = value;
                    break;
                }
            }

            if (
                property !== 'currentlyManagedProjectId' &&
                property !== 'isLdap' &&
                property !== 'customerExternalId' &&
                property !== 'customerName'
            ) {
                this.validator.execute(this.user, property);
            }
        },
        handleClose() {
            setTimeout(() => this.clear(), 300);
            this.$emit('close');
        },
        async handleAddDuplicateEmail() {
            await this.handleSave(true);
            this.handleCancelDuplicateEmail();
        },
        handleCancelDuplicateEmail() {
            this.duplicateEmailError = false;
            this.processing = false;
        },
        async handleStepChange(newStep) {
            this.currentStep = newStep;
        },
        handleValid(property) {
            this.validator.execute(this.user, property);
        },
        handleSelectAll(property, allSelected) {
            if (allSelected) {
                this.user.deselectAll(property);
            } else {
                this.user.selectAll(property);
            }
            this.validator.execute(this.user, property);
        },
        clear() {
            this.errored = false;
            this.errors = [];
            this.duplicateEmailError = false;
            this.validator = new UserValidator();
            this.currentlyManagedProjectId = -1;
            this.currentStep = 0;
        },
        addActiveProjectAsDefaultSelected(selected = true) {
            const activeProjectId = Laravel.activeProject;
            const activeProject = this.user.findAvailableProject(activeProjectId);

            this.user.updateProject({...activeProject, selected});
        },
        async load(keepData) {
            this.processing = true;

            this.clear();

            if (this.addMode && !keepData) {
                const url = `/administration/user/edit/data/`;
                const api = new API(url);
                const response = await api.get();

                if (response.errored) {
                    this.processing = false;
                    return ;
                }

                this.user = new EditUser(response);

                this.addActiveProjectAsDefaultSelected();
            }

            if (!this.addMode) {
                const url = `/administration/user/edit/data/${this.id}`;
                const api = new API(url);
                const response = await api.get();
                const {userData, ...other} = response;

                this.user = new EditUser({...userData, ...other});
            }

            this.processing = false;
        },
        async handleSave(addExistingUser = false) {
            this.processing = true;

            const url = this.addMode
                ? `/administration/user/addNew`
                : `/administration/user/edit`;
            const api = new API(url);

            const data = this.user.prepareUserForAPI();
            if (addExistingUser) data.addExistingUser = 1;

            const result = await api.post(data, this.errorCallback);

            if (!this.duplicateEmailError) {
                this.processing = false;
            }

            if (result.errored) {
                this.errored = true;
                if (!this.duplicateEmailError) toaster.error(this.doneMessage);
            } else {
                this.errored = false;
                toaster.success(this.doneMessage);
            }

            EaseEventBus.fire('reloadUserTable');
        },
        async handleRestart(withoutClear) {
            await this.load(withoutClear)
        },
        async errorCallback(response, timeout) {
            if (response.status === 401) {
                const message = Lang.langGet('Unauthorized. Please login!');
                toaster.error(message);
                setTimeout(() => {
                    window.location = '/login';
                }, timeout)
                return;
            }

            const contentType = response.headers.get("Content-Type");

            if (!contentType.includes('json')) {
                return;
            }

            const data = await response.json();
            if (!data) return;

            if (data.errors?.email) {
                const hasDuplicateError = data?.errors?.email.find(error => error.unique);
                if (hasDuplicateError) {
                    this.duplicateEmailError = true;
                }
            }

            if (data.errors && !_.isEmpty(data?.errors)) {
                Object.keys(data.errors).forEach(errorKey => {
                    const errors = data.errors[errorKey];
                    errors.forEach(error => {
                        if (_.isObject(error)) {
                            const firstProperty = Object.keys(error)[0];
                            this.addErrors(error[firstProperty]);
                        } else {
                            this.addErrors(error);
                        }
                    })
                })
            }

            return data;
        },
        addErrors(error) {
            this.errors.push(error);
            // console.log('Errors: ', this.errors);
        }
    },
    mounted() {
        this.load();
    },
    watch: {
        show(newShowDialog) {
            if (newShowDialog) {
                this.load();
            }
        }
    }
}
</script>

<template>
    <div>
        <confirm-dialog :showDialog="duplicateEmailError"
            :title="translations.userExistsTitle"
            :message="userExistsMsg"
            :confirmMsg="projectNames"
            noIcons
            @confirm="handleAddDuplicateEmail"
            @cancel="handleCancelDuplicateEmail"
        />
        <loading :loading="processing" />
        <wizard-steps
            class="ma-4"
            @click="handleStepChange"
            :currentStep="currentStep"
            :steps="steps"
        />
        <wizard-body :height="60">
            <div v-if="currentStep === 0" style="height: inherit">
                <user-wizard-header :text="generalMessage"/>
                <user-wizard-general v-if="!processing"
                    :user="user"
                    :add-mode="addMode"
                    :validator="validator"
                    :addMode="addMode"
                    @input="handleChange"
                    @valid="handleValid"
                />
            </div>
            <div v-if="currentStep === 1" class="d-flex flex-column h-100">
                <user-wizard-header :text="projectsMessage"/>
                <user-wizard-projects v-if="!processing"
                    :user="user"
                    :validator="validator"
                    @input="handleChange"
                    @valid="handleValid"
                    @selectAll="handleSelectAll"
                />
            </div>
            <div v-if="currentStep === 2" class="d-flex flex-column h-100">
                <user-wizard-header :text="groupingMessage"/>
                <user-wizard-grouping v-if="!processing"
                    :currentlyManagedProjectId="currentlyManagedProjectId"
                    :user="user"
                    :validator="validator"
                    @input="handleChange"
                    @valid="handleValid"
                    @selectAll="handleSelectAll"
                />
            </div>
            <div v-if="currentStep === 3" class="d-flex flex-column h-100">
                <user-wizard-header v-if="processing" :text="translations.processing"/>
                <user-wizard-header v-if="errored && !processing" error :text="doneMessage"/>
                <user-wizard-header v-if="!errored && !processing" success :text="doneMessage"/>
                <user-wizard-done v-if="!processing"
                    :user="user"
                    :errors="errors"
                    :errored="errored"
                    :processing="processing"
                    @stepping="handleStepChange"
                    @restart="handleRestart"
                />
            </div>
        </wizard-body>
        <wizard-footer
            :errored="errored"
            :currentStep="currentStep"
            :steps="steps"
            :invalid="validator.isInvalid()"
            :invalidProperties="validator.getDisplayTextForInvalidProperties()"
            :addMode="addMode"
            :processing="processing"
            @stepping="handleStepChange"
            @save="handleSave"
            @restart="handleRestart"
            @close="handleClose"
        />
    </div>
</template>

